import React, { useState, useRef } from 'react';
import { Link } from "react-router-dom";
import Barcode from 'react-barcode';

const BarcodeGenerator = () => {
    const [patientId, setPatientId] = useState('');
    const [name, setName] = useState('');
    const [dob, setDob] = useState('');
    const [barcodeValue, setBarcodeValue] = useState('');
    const printRef = useRef(null); // ✅ Properly defined here

//   const formatBarcode = () => {
//     const id = patientId.trim().toUpperCase();
//     const [lastName, firstName] = name.trim().toUpperCase().split(',');
//     const dobFormatted = dob.replace(/-/g, '').slice(2); // YYMMDD

//     const payload = `${id}${(lastName || '').slice(0, 3)}${(firstName || '').charAt(0)}${dobFormatted}`;
//     setBarcodeValue(payload.slice(0, 22)); // enforce 22-char limit
//   };
 const formatBarcode = () => {
  const id = patientId.trim().toUpperCase(); // e.g., "132"
  const [lastNameRaw, firstNameRaw] = name.trim().toUpperCase().split(',');
  const lastName = (lastNameRaw || '').replace(/[^A-Z]/g, '').slice(0, 3); // "DOE"
  const firstInitial = (firstNameRaw || '').replace(/[^A-Z]/g, '').charAt(0); // "J"
  const dobFormatted = dob.replace(/-/g, '').slice(2); // "YYMMDD"

  // Final payload: ID + LastName[0:3] + FirstInitial + DOB
  const payload = `${id}${lastName}${firstInitial}${dobFormatted}`.slice(0, 22);

  setBarcodeValue(payload);
};


 const handlePrint = () => {
    const printContents = printRef.current.innerHTML;
    const printWindow = window.open('', '', 'width=600,height=400');
    printWindow.document.write(`
      <html>
        <head>
          <title>Print Barcode</title>
          <style>
            body { font-family: Arial; padding: 20px; }
            .barcode-label { text-align: center; }
            .barcode-label p { margin: 8px 0; font-size: 14px; }
          </style>
        </head>
        <body onload="window.print(); window.close();">
          <div class="barcode-label">${printContents}</div>
        </body>
      </html>
    `);
    printWindow.document.close();
  };

  return (
    <div style={{ padding: '2rem', fontFamily: 'Arial' }}>
      <Link to="/home"><button className='ris-little-blue-button'>Home</button></Link>
      <h2>Patient Barcode Generator</h2>

      <label>Patient ID:</label>
      <input value={patientId} onChange={e => setPatientId(e.target.value)} />

      <label>Patient Name (Last, First):</label>
      <input value={name} onChange={e => setName(e.target.value)} />

      <label>Date of Birth (YYYY-MM-DD):</label>
      <input type="date" value={dob} onChange={e => setDob(e.target.value)} />

      <button onClick={formatBarcode} style={{ marginTop: '1rem' }}>Generate Barcode</button>

      {barcodeValue && (
        <div style={{ marginTop: '2rem' }}>
          <div ref={printRef}>
            <Barcode value={barcodeValue} format="CODE128" />
            <p>{barcodeValue}</p>
            <p>{name.trim()} | DOB: {dob}</p>
          </div>
          <button onClick={handlePrint} style={{ marginTop: '1rem' }}>Print Label</button>
        </div>
      )}
    </div>
  );
};

export default BarcodeGenerator;
